import { render, staticRenderFns } from "./CommunityStandards.vue?vue&type=template&id=2ec7c6ae&scoped=true"
import script from "./CommunityStandards.vue?vue&type=script&lang=js"
export * from "./CommunityStandards.vue?vue&type=script&lang=js"
import style0 from "./CommunityStandards.vue?vue&type=style&index=0&id=2ec7c6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7c6ae",
  null
  
)

export default component.exports